import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from 'src/app/services/storage.service';


@Component({
  selector: 'app-sidenav-content',
  templateUrl: './sidenav-content.component.html',
  styleUrls: ['./sidenav-content.component.scss'],
})
export class SidenavContentComponent {
  constructor(
    private router: Router,
     private storage: StorageService,
     private translate: TranslateService
    ) {}

  goToPage(pageName: string) {
    let baniLanguage = localStorage.getItem('language');
    let baniLanguageString =
      baniLanguage && baniLanguage === 'en' ? 'english' : 'panjabi';
    this.router.navigate([`info/${baniLanguageString}/${pageName}`]);
  }

  openPage(pageUrl: string) {
    window.open(pageUrl, '_blank');
  }

  goToSearchPage(): void {
    this.router.navigate(['/search']);
  }

  goToSimplePage(pageName: string) {
    this.router.navigate([`/${pageName}`]);
  }

  fetchLanguage(): string | null {
    return this.storage.get('language');
  }

  onSelectLanguage(language: string) {
    // console.log(language);
    this.storage.set('language', language);
    let thisUrl = this.router.url;
    if (thisUrl === '/') thisUrl = '/home';
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      // in this case we should set the language as set for the website if needed
      if (thisUrl.includes('english') || thisUrl.includes('panjabi')) {
        let baniLanguage = localStorage.getItem('language');
        let baniLanguageString =
          baniLanguage && baniLanguage === 'en' ? 'english' : 'panjabi';

        if (thisUrl.includes('english')) {
          thisUrl = thisUrl.replace(/english/g, String(baniLanguageString));
        } else {
          thisUrl = thisUrl.replace(/panjabi/g, String(baniLanguageString));
        }
      }
      let baniLanguage = localStorage.getItem('language');
      if (baniLanguage) this.translate.use(baniLanguage);

      this.router.navigate([thisUrl]);
    });
  }
   onDonateClick(): void {
    const donateUrl = 'https://sikhri.org/donate';
    window.open(donateUrl, '_blank');
  }

}
